var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9912 14.5273C12.29 14.5273 12.5273 14.29 12.5273 14V4.53418L12.4922 3.25977L13.2744 4.06836L14.7686 5.62402C14.8652 5.72949 15.0059 5.78223 15.1377 5.78223C15.4189 5.78223 15.6299 5.58008 15.6299 5.30762C15.6299 5.1582 15.5771 5.05273 15.4717 4.94727L12.3867 1.92383C12.2549 1.79199 12.1318 1.74805 11.9912 1.74805C11.8594 1.74805 11.7363 1.79199 11.6045 1.92383L8.51074 4.94727C8.40527 5.05273 8.35254 5.1582 8.35254 5.30762C8.35254 5.58008 8.55469 5.78223 8.83594 5.78223C8.96777 5.78223 9.11719 5.72949 9.21387 5.62402L10.708 4.06836L11.499 3.25977L11.4551 4.53418V14C11.4551 14.29 11.7012 14.5273 11.9912 14.5273ZM6.9375 21.2949H17.0537C18.7676 21.2949 19.6465 20.416 19.6465 18.7285V9.74609C19.6465 8.0498 18.7676 7.1709 17.0537 7.1709H14.5488V8.26074H17.0273C18.0029 8.26074 18.5566 8.78809 18.5566 9.79883V18.667C18.5566 19.6865 18.0029 20.2051 17.0273 20.2051H6.95508C5.9707 20.2051 5.43457 19.6865 5.43457 18.667V9.79883C5.43457 8.78809 5.9707 8.26074 6.95508 8.26074H9.45117V7.1709H6.9375C5.22363 7.1709 4.34473 8.04102 4.34473 9.74609V18.7285C4.34473 20.4248 5.22363 21.2949 6.9375 21.2949Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.1f19d8d81df257b4d8b09e60776ff6f3.svg";
export { ForwardRef as ReactComponent };